// eslint-disable-next-line no-shadow
export enum GenerationStyleTabs {
	LIGHTNING_MODE = 'lightning',
	FLUX_MODE = 'flux',
	MAGIC_MODE = 'magicmode',
	PRO_MODE = 'promode',
}
